export const HOME_VIEW_TEST_IDS = {
  container: "HomeView-container",
  welcomeMessage: "HomeView-welcome-message",
  greeting: "HomeView-greeting",
  heroTitle: "HomeView-hero-title",
  partnershipText: "HomeView-partnership-text",
  portalDescription: "HomeView-portal-description",
  valueProp: "HomeView-value-prop",
  tagline: "HomeView-tagline",
} as const;
